import React from "react";

export default function PageHeader({ title, description }) {
  return (
    <div className="mb-6">
      <h1 className="text-3xl font-semibold mb-2 text-gray-800">
        {title}
      </h1>
      {description && (
        <p className="text-gray-600 text-sm">{description}</p>
      )}
    </div>
  );
}
